import { render, staticRenderFns } from "./StoreQueueList.vue?vue&type=template&id=997bcc28&scoped=true&"
import script from "./StoreQueueList.vue?vue&type=script&lang=js&"
export * from "./StoreQueueList.vue?vue&type=script&lang=js&"
import style0 from "./StoreQueueList.vue?vue&type=style&index=0&id=997bcc28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997bcc28",
  null
  
)

export default component.exports